import { CommandType } from '../constants/Constants';
import BaseCommand from './BaseCommand';

/**
 * 空命令，以防万一 擦枪走火
 *
 * @export
 * @class CmdNull
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdNull extends BaseCommand {
  constructor() {
    super();
    this.type = CommandType.Null;
  }
}
